/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Default_HighlightInputs */

const en_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ar_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معًا`)
};

const bn_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বানাই`)
};

const de_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bauen`)
};

const es_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`construir`)
};

const fr_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ensemble`)
};

const pt_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`construir`)
};

const zh_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建`)
};

const tr_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derleme`)
};

const ru_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборка`)
};

const pl_heading_contact_default_highlight = /** @type {(inputs: Heading_Contact_Default_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacja`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Heading_Contact_Default_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_default_highlight = /** @type {((inputs?: Heading_Contact_Default_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Default_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_default_highlight(inputs)
	if (locale === "bn") return bn_heading_contact_default_highlight(inputs)
	if (locale === "de") return de_heading_contact_default_highlight(inputs)
	if (locale === "es") return es_heading_contact_default_highlight(inputs)
	if (locale === "fr") return fr_heading_contact_default_highlight(inputs)
	if (locale === "pt") return pt_heading_contact_default_highlight(inputs)
	if (locale === "zh") return zh_heading_contact_default_highlight(inputs)
	if (locale === "tr") return tr_heading_contact_default_highlight(inputs)
	if (locale === "ru") return ru_heading_contact_default_highlight(inputs)
	if (locale === "pl") return pl_heading_contact_default_highlight(inputs)
	return en_heading_contact_default_highlight(inputs)
});